import geneesmiddelApi from "../../api/geneesmiddelApi";

export default class VerbodenStofDetailPageHelper {
    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const context = this.context;
        const props = context.props;
        const ajaxActions = props.ajaxActions;
        const params = props.match.params;
        const geneesmiddelId = params.geneesmiddelId;
        const verbodenStofId = params.verbodenStofId;

        ajaxActions.started();
        geneesmiddelApi.get(geneesmiddelId)
            .then((response) => {
                ajaxActions.ended();
                this._processModel(response.data.stoffen.find(s => s.id === verbodenStofId));
            })
            .catch((ex) => {
                ajaxActions.failed();
                props.throwException(ex);
            });
    }

    _processModel(verbodenStof) {
        this.context.setState({
            model: verbodenStof
        });
    }
}